import classNames from 'classnames';
import styles from '@/components/Kanban/VisibilitySettings/index.less';
import { F } from '@/utils/intl';
import { Flex, Switch, Tag } from 'antd';
import { SortableItem } from '@/components/Kanban/VisibilitySettings/SortableItem';
import React from 'react';
import { LEAD_PROPERTY_COLUMN_SETTINGS } from '@/components/Lead/LeadProperties';
import { CUSTOMER_PROPERTY_COLUMN_SETTINGS } from '@/components/CustomerDrawer/constants';
import { APPOINTMENT_PROPERTY_COLUMN_SETTINGS } from '@/components/Appointment/AppointmentProperties';

type IPropertyProps = {
  id: string,
  languageKey?: string,
  title?: string,
  groupTitle?: string | null,
  isVisible: boolean,
  className?: string,
  hasSort?: boolean,
  isDragging?: boolean,
  isCustomField?: boolean
}
export default function Property({id, groupTitle, languageKey, title, isVisible, className, hasSort, isDragging, isCustomField}: IPropertyProps) {
  const columnTitle = languageKey
    ? (LEAD_PROPERTY_COLUMN_SETTINGS[languageKey] || CUSTOMER_PROPERTY_COLUMN_SETTINGS[languageKey] || APPOINTMENT_PROPERTY_COLUMN_SETTINGS?.[languageKey])?.title
    : undefined;
  return (
    <SortableItem
      id={id}
      hasSort={isVisible && hasSort}
      className={classNames(styles.fieldListItem, className)}
    >
      <Flex vertical>
        <Flex align={'center'} gap={4}>
          {languageKey ? (
            <F
              id={`pages.lead.fields.${languageKey}`}
              defaultMessage={
                <F {...(columnTitle || { id: `pages.lead.fields.${languageKey}`, defaultMessage: languageKey })} />
              }
            />
          ) : (
            title
          )}
          {isCustomField && (
            <Tag className={styles.customFieldTag}>
              <F id={'common.fields.customTag'} defaultMessage={'Custom'} />
            </Tag>
          )}
        </Flex>
        {groupTitle ? (
          <small style={{ lineHeight: 0.8, fontSize: 9, opacity: 0.7 }}>
            {groupTitle}
          </small>
        ) : (
          ''
        )}
      </Flex>
      {!isDragging && <Switch size={'small'} checked={isVisible} />}
    </SortableItem>
  );
}
